module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--philips-b7dad2b2.png";